import React, { useState, useEffect } from 'react';
import { Modal, Tooltip } from 'antd';
import {
  Widget,
  FormInput,
  MasterDetailForm,
  Button,
  Col,
  notification,
  FormSelect,
  FormCheckbox,
  FormSwitch,
} from '@digital/ui';
import { creatNovaPlanilha } from '@app/api/planilhaRateio';

const FormNovaPlanilha = props => {
  const {
    mostrarModal,
    tipoDocumentoCobrancaOptions,
    municipiosOptions,
    medicaoId,
    pisCofinsContrato,
    CallbackNovaPlanilha,
  } = props;
  const [showModal, setShowModal] = useState<boolean>(mostrarModal);
  const [municipio, setMunicipio] = useState();
  const [tipoDocumento, setTipoDocumento] = useState();
  const [pisCofins, setPisCofins] = useState<boolean>(false);

  const createPlanilha = () => {
    creatNovaPlanilha({ medicaoId, municipio, tipoDocumento, pisCofins }).then(data => {
      setTipoDocumento(undefined);
      setMunicipio(undefined);
      setPisCofins(false);
      setShowModal(false);
      CallbackNovaPlanilha();
    });
  };

  const zerarValores = () => {
    setTipoDocumento(undefined);
    setMunicipio(undefined);
    setPisCofins(false);
  };

  return (
    <>
      <Button
        id={'btnNovaPlanilha'}
        type="link"
        icon="data-data_recovery"
        onClick={() => {
          zerarValores();
          setShowModal(true);
        }}>
        Novo Rateio
      </Button>
      <Modal
        visible={showModal}
        width={620}
        title="Novo Rateio"
        onCancel={() => {
          setShowModal(false);
        }}
        footer={[
          <Button
            key="back"
            type="link"
            onClick={() => {
              setShowModal(false);
            }}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              createPlanilha();
            }}>
            Incluir
          </Button>,
        ]}>
        <MasterDetailForm onSubmit={data => createPlanilha(data)}>
          <Widget>
            <FormSelect
              options={tipoDocumentoCobrancaOptions}
              name="tipoDocumentoCobranca"
              label="Tipo de Documento de Cobrança"
              span={6}
              required
              value={tipoDocumento}
              onChange={e => {
                setTipoDocumento(e);
              }}
            />
            <FormSelect
              options={municipiosOptions}
              name="municipio"
              label="Município"
              span={6}
              required
              value={municipio}
              onChange={e => {
                setMunicipio(e);
              }}
            />
            {pisCofinsContrato == true ? (
              <FormSwitch
                label="COM PIS/COFINS?"
                name="pisCofins"
                span={4}
                checked={pisCofins}
                onChange={e => {
                  setPisCofins(e);
                }}
              />
            ) : (
              <></>
            )}
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default FormNovaPlanilha;
